import { render } from "./waterWayPage.vue?vue&type=template&id=472da402&scoped=true"
import script from "./waterWayPage.vue?vue&type=script&lang=js"
export * from "./waterWayPage.vue?vue&type=script&lang=js"

import "./waterWayPage.vue?vue&type=style&index=0&id=472da402&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472da402"]])

export default __exports__